import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { useEffect } from "react";
import OperationReportService from "../../../Services/Reports/OperationReportService";
import { getDate } from "../../Utils/Common";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  border: " 1px solid black",
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
}));
function FundRequestEmployeeReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "12rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: 'Times New Roman',
  };

  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [loading, setloading] = useState(false)
  const [showProcs, setshowProcs] = useState(false)
  const [exportExcelProcs, setexportExcelProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [fundRqEmpValues, setfundRqEmpValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: 'ALL',
    empname: 'ALL',
  });
  const fromhandlechange = (e) => {
    setfundRqEmpValues({ ...fundRqEmpValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setfundRqEmpValues({ ...fundRqEmpValues, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setfundRqEmpValues({ ...fundRqEmpValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const empnmhandlechange = (e) => {
    setfundRqEmpValues({ ...fundRqEmpValues, empname: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  ///getfunctions
  const getfunctions = () => {
    OperationReportService.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
    OperationReportService.getEmployeeDetails().then(res => {
      setdetails2(res.data);
    })
  }
  // btnOperations
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    var employeeId, regionalId = '';
    if (fundRqEmpValues.empname === 'ALL') {
      employeeId = -1
    } else {
      employeeId = fundRqEmpValues.empname;
    }
    if (fundRqEmpValues.branch === 'ALL') {
      regionalId = -1
    } else {
      regionalId = fundRqEmpValues.branch;
    }
    let details = { fromDate: fundRqEmpValues.from, toDate: fundRqEmpValues.to, employeeId: employeeId, regionalId: regionalId, flag: 1 };
    OperationReportService.getFundReqEmployeeReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const ExportExcelClick = () => {
    setexportExcelProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setexportExcelProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].operationType !== '') {
          tableContent = details3[i].operationType + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].consignmentNumber !== '') {
          tableContent += details3[i].consignmentNumber + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].status !== '') {
          tableContent += details3[i].status + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].regionalName !== '') {
          tableContent += details3[i].regionalName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].customPointName !== '') {
          tableContent += details3[i].customPointName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importer_name !== '') {
          tableContent += details3[i].importer_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].forwarder_name !== '') {
          tableContent += details3[i].forwarder_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawbNo !== '') {
          tableContent += details3[i].mawbNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawb_date !== '') {
          tableContent += details3[i].mawb_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawb_no !== '') {
          tableContent += details3[i].hawb_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawbDate !== '') {
          tableContent += details3[i].hawbDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].IgmNo !== '') {
          tableContent += details3[i].igmNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igmDate !== '') {
          tableContent += details3[i].igmDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalPcs !== '') {
          tableContent += details3[i].totalPcs + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalWeight !== '') {
          tableContent += details3[i].totalWeight + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beType !== '') {
          tableContent += details3[i].beType + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].boe_no !== '') {
          tableContent += details3[i].boe_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].boe_date !== '') {
          tableContent += details3[i].boe_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalInvoice !== '') {
          tableContent += details3[i].totalInvoice + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceValue !== '') {
          tableContent += details3[i].invoiceValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalCarton !== '') {
          tableContent += details3[i].totalCarton + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].assbleValue !== '') {
          tableContent += details3[i].assbleValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyAmount !== '') {
          tableContent += details3[i].dutyAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].drawbackAmt !== '') {
          tableContent += details3[i].drawbackAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].currency_code !== '') {
          tableContent += details3[i].currency_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].reqDate !== '') {
          tableContent += details3[i].reqDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].reqName !== '') {
          tableContent += details3[i].reqName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].allocatedDate !== '') {
          tableContent += details3[i].allocatedDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].allocatedName !== '') {
          tableContent += details3[i].allocatedName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].firstLevelDate !== '') {
          tableContent += details3[i].firstLevelDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].firstLevelName !== '') {
          tableContent += details3[i].firstLevelName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].secondLevelDate !== '') {
          tableContent += details3[i].secondLevelDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].secondLevelName !== '') {
          tableContent += details3[i].secondLevelName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].allocatedDate !== '') {
          tableContent += details3[i].allocatedDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].allocatedName !== '') {
          tableContent += details3[i].allocatedName + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,FUND REQUEST EMPLOYEE REPORT", headerDetails: "1,1,FROM DATE : " + fundRqEmpValues.from + "/4,1,TO DATE : " + fundRqEmpValues.to,
        tableHeader: "0,3,Sl.No/1,3,Operation/2,3,Job No/3,3,Job Status/4,3,Branch/5,3,Edi Location/6,3,Customer Name/7,3,Forwarder Name/8,3,MAWB_MBL No/9,3,MAWB_MBL Date/10,3,HAWB_HBL No/11,3,HAWB_HBL Date/12,3,IGM No/13,3,IGM Date/14,3,Total Pcs/15,3,Total Weight/16,3,BE_SB Type/17,3,BE_SB No/18,3,BE_SB Date/19,3,No of Invoice/20,3,Total Invoice Value/21,3,No of Item/22,3,Asseseble Value/23,3,Duty Amount/24,3,Drawback Amount/25,3,Invoice Currency/26,3,Request Date/27,3,Request By/28,3,Approval Date/29,3,Approval By/30,3,FirstLevel Verified Date/31,3,FirstLevel Verify By/32,3,SecondLevel Verify Date/33,3,SecondLevel Verify By/34,3,Allocated Date/35,3,Allocated By",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "FundReq", totalNumberOfColumn: 36, tableContent: contenall.substring(0, contenall.length - 1),
      }
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setexportExcelProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);
  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const ediLocSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { ediLocOnchange(e.target.value) }} />
  }
  const CusNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { CusNmOnchange(e.target.value) }} />
  }
  //
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const ediLocOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.customPointName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const CusNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.importer_name.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}>
              <center>FUND REQUEST WISE EMPLOYEE REPORT</center></div>
            <Row>
              <Col><center>
                <label style={mystyle1}>From Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={fundRqEmpValues.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>To Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={fundRqEmpValues.to} onChange={tohandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Branch Name</label>
                <Form.Select size="sm" style={mystyle} value={fundRqEmpValues.branch} onChange={branchhandlechange}>
                  {details1.map(trns => (
                    <option value={trns.regionId}>{trns.regionalName}</option>
                  ))}
                </Form.Select></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Employee Name</label>
                <Form.Select size="sm" style={mystyle} value={fundRqEmpValues.empname} onChange={empnmhandlechange}>
                  {details2.map(trns => (
                    <option value={trns.employeeId}>{trns.employeeName}</option>
                  ))}
                </Form.Select></center>
              </Col>
            </Row>
            <Row className='mb-1 mt-2'>
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button variant="primary"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={showBtnClick}> {showProcs ? 'processing...' : 'Show'} </Button>
                &nbsp;
                <Button variant="success"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={ExportExcelClick}> {exportExcelProcs ? 'processing...' : 'Export Excel'}</Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 410 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>Operation</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobStatus</StyledTableCell>
                      <StyledTableCell>Branch</StyledTableCell>
                      <StyledTableCell>EDI_Location{ediLocSrch()}</StyledTableCell>
                      <StyledTableCell>CustomerName{CusNmSrch()}</StyledTableCell>
                      <StyledTableCell>ForwarderName</StyledTableCell>
                      <StyledTableCell>MAWB_Mbl_No</StyledTableCell>
                      <StyledTableCell>MAWB_Mbl_Date</StyledTableCell>
                      <StyledTableCell>HAWB_Mbl_No</StyledTableCell>
                      <StyledTableCell>HAWB_Mbl_Date</StyledTableCell>
                      <StyledTableCell>IGM_No</StyledTableCell>
                      <StyledTableCell>IGM_Date</StyledTableCell>
                      <StyledTableCell>Total_Pcs</StyledTableCell>
                      <StyledTableCell>Total_WT</StyledTableCell>
                      <StyledTableCell>BE_SB_Type</StyledTableCell>
                      <StyledTableCell>BE_SB_No</StyledTableCell>
                      <StyledTableCell>BE_SB_Date</StyledTableCell>
                      <StyledTableCell>No_Of_Invoice</StyledTableCell>
                      <StyledTableCell>Tot_Inv_Value</StyledTableCell>
                      <StyledTableCell>No_Of_Item</StyledTableCell>
                      <StyledTableCell>Assessable_Value</StyledTableCell>
                      <StyledTableCell>Duty_Amount</StyledTableCell>
                      <StyledTableCell>DrawBack_Amount</StyledTableCell>
                      <StyledTableCell>InvoiceCurrency</StyledTableCell>
                      <StyledTableCell>Request_Date</StyledTableCell>
                      <StyledTableCell>Request_By</StyledTableCell>
                      <StyledTableCell>Approved_Date</StyledTableCell>
                      <StyledTableCell>Approved_By</StyledTableCell>
                      <StyledTableCell>1stLvlVerify_Date</StyledTableCell>
                      <StyledTableCell>1stLvlVerify_By</StyledTableCell>
                      <StyledTableCell>2ndstLvlVerify_Date</StyledTableCell>
                      <StyledTableCell>2ndLvlVerify_By</StyledTableCell>
                      <StyledTableCell>Allocated_Date</StyledTableCell>
                      <StyledTableCell>Allocated_By</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.status}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.customPointName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.forwarder_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawb_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalPcs}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalWeight}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalInvoice}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalCarton}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.assbleValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.dutyAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.drawbackAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.currency_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.reqName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.firstLevelName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.secondLevelName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.allocatedName}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default FundRequestEmployeeReport;
